import React, {useState, useEffect, useRef, useMemo} from "react";
import { Link , useParams, useNavigate, useLocation  } from "react-router-dom";
import {
    API_ENDPOINT,     
    APP_URL, 
    APP_NAME,
    IMG_URL,
} from '../components/config/Common'
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import {useScreenQuery} from '../data/screen-details';
import {useSectorQuery} from '../data/sector-details';

import {Links} from '../routes/PathLink'
import Breadcrumb  from "../components/Breadcrumb";
import Seo from 'components/seo/seo'
import Input from '../components/ui/input.jsx';
import { BsSearch } from "react-icons/bs";

const Screens = () => {
    const [metaTitle, setMetaTitle] = useState('Explore Stock Screens & Build Your Own | Advanced Stock Screener')
    const [metaDesc, setMetaDesc] = useState('Find top-performing stocks with ready-made screens or create personalized stock screens based on your criteria. Simple, powerful, and investor-friendly.')

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const [orderBy, setOrder] = useState('created_at');
    const [sortedBy, setColumn] = useState('desc');
    const [searchQuery, setSearchQuery] = useState(null);

    const {
        product,
        screenDetails,
        paginatorInfo,
        isLoading,
        error,
    } = useScreenQuery({         
        limit: pageSize,
        page,    
        orderBy,
        sortedBy,
    });

    const {
        sectors,
    } = useSectorQuery({         
        limit: pageSize,
        page,    
        orderBy,
        sortedBy,
        search:searchQuery,
    }); 
    
    //console.log('sector count', sectors)

    const breadcrumb = [
      {
        name:'Home',
        link:`${process.env.REACT_APP_URL}`,
      },
      {
        name:`Screens`,
        link:null
      },
    ]

    const searchSector = (val) => {
      //console.log('sq---', val)
      setSearchQuery(val)
    }

    return (
        <>
        <Seo 
        title={`${metaTitle} - ${APP_NAME}`}
        desc={metaDesc && metaDesc.substring(0, 200)}
        url={`${APP_URL}/screens`}
      />
            <Header  />
            <div className="space-y-5 px-5 lg:px-8">                
                <Breadcrumb breadcrumb={breadcrumb} />
                <div className="flex w-full gap-8 flex-wrap justify-between">
                    
                    <section className="w-full lg:w-[60%]">                        
                        <div className="flex flex-wrap items-center justify-between">
                            <h1 className="py-5 text-heading text-2xl">Stock Screens</h1>
                            <Link to={`${APP_URL}${Links.SCREENS}/create`} className="group border border-accent rounded px-3 py-2 bg-accent transition-colors duration-300">
                                <div className="text-white transition-colors duration-300">Create New Screen</div>
                            </Link>
                        </div>
                        
                        <div className="bg-white shadow-sm rounded-xl p-5">
                            <div className="flex flex-wrap w-full items-center justify-between gap-3">
                            {product?.map((val, key) => (
                                <div className="border rounded p-3 w-full lg:w-[48%] hover:shadow-lg transition-shadow duration-300">
                                    <Link to={`${APP_URL}${Links.SCREENS}/${val.slug}`}>
                                    <h2 className="text-heading text-lg text-gray-500 truncate">{val.title}</h2>
                                    <div className="text-gray-500 truncate" dangerouslySetInnerHTML={{__html: val.description || ''}}></div>
                                    </Link>
                                </div>
                            ))
                            }
                            </div>
                        </div>
            
                    </section>
                    <section className="w-full lg:w-[37%] bg-white shadow-sm rounded-xl px-5 py-3">
                        <div className="flex flex-row items-center justify-between gap-5 pb-5">
                        <h1 className="text-heading text-2xl pt-3">Sectors</h1>
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 top-3 flex items-center pl-3 pointer-events-none">
                            <BsSearch className="w-3 h-3 text-black" />
                            </div>
                            <Input 
                            dimension='small' 
                            onChange={(e) => searchSector(e.target.value)} 
                            value={searchQuery}
                            placeholder='Search sector by name...'
                            inputClassName="!h-8 !pl-8 !w-[50px] focus:!w-[250px] transition-[width] duration-300 ease-in-out"
                            />
                        </div>
                        </div>

                        <div className="flex flex-wrap w-full items-center justify-start gap-3">
                            {sectors?.map((val, key) => (
                                <div className="group border border-default rounded px-3 py-2 hover:bg-accent transition-colors duration-300">
                                    <Link to={`${APP_URL}${Links.SECTORS}/${val.slug}`}>
                                    <div className="text-sm text-gray-500 group-hover:text-white transition-colors duration-300">{val.name} <span className="text-xs">[{val.company_count}]</span></div>
                                    </Link>
                                </div>
                            ))
                            }
                            </div>
                    </section>
                </div>
            </div>

            <Footer />
        </>
    )

}
export default Screens;